import { loopThroughElements } from "../utils/loop-through-elements";

export class Collapsible {
    constructor() {
        this.bindEvents();
    }

    bindEvents = (): void => {
        this.enableKeyboardControl();
        this.preventBubble();
    }

    enableKeyboardControl = (): void => loopThroughElements(document.querySelectorAll('label.collapsible'), l => {
        l.addEventListener('keydown', e => {
            if (e.which === 32 || e.which === 13) {
                // space or enter pressed
                e.preventDefault();
                l.click();
            }
        })
    });

    preventBubble = (): void => loopThroughElements(document.getElementsByClassName('collapsible__content__inner'), (el: HTMLElement) =>
        el.addEventListener('keydown', (evt: Event) => evt.stopPropagation())
    );

    handleCollapse = (labelElement: HTMLLabelElement, event: MouseEvent): void => {
        console.log('using custom handler');
        event.stopPropagation();

        const content = labelElement.getElementsByClassName('collapsible__content')[0];
        if (content.contains(event.target as Element)) {
            console.log('event is in content, ignoring');
            return;
        }

        const preScroll = labelElement.getBoundingClientRect().y + window.scrollY;
        const checkbox = labelElement.firstElementChild as HTMLInputElement;
        checkbox.checked = !checkbox.checked;

        const postScroll = labelElement.getBoundingClientRect().y + window.scrollY;
        if (preScroll != postScroll) {
            const offset = postScroll - preScroll;
            console.info(`Adjusting vertical scroll by up to ${offset}px.`);
            window.scrollBy(0, offset);
        }
    }
}